import { useEffect, useRef } from "react";

const IUBENDA_SRC = "https://cdn.iubenda.com/iubenda.js";

const PRIVACY_HREF = "https://www.iubenda.com/privacy-policy/86256626";
const COOKIE_HREF =
  "https://www.iubenda.com/privacy-policy/86256626/cookie-policy";

/**
 * Renders the iubenda Privacy Policy and Cookie Policy as plain text links.
 *
 * iubenda.js decorates any `.iubenda-embed` anchor into a fixed-size badge with
 * a green shield and binds the click-to-open modal to it — and that styling is
 * near-impossible to override cleanly. So instead we keep the iubenda-decorated
 * anchors hidden (purely to register the modal handlers) and show our own plain
 * text links that forward their clicks to the hidden ones. We get clean links
 * AND the in-page modal.
 */
export const IubendaPolicies = () => {
  const privacyRef = useRef(null);
  const cookieRef = useRef(null);

  useEffect(() => {
    if (document.querySelector(`script[src="${IUBENDA_SRC}"]`)) return;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = IUBENDA_SRC;
    script.async = true;
    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  }, []);

  const open = (ref, href) => (e) => {
    e.preventDefault();
    // Forward the click to iubenda's decorated anchor to open the modal.
    // Fall back to navigating if iubenda hasn't loaded (e.g. blocked).
    if (ref.current) {
      ref.current.click();
    } else {
      window.open(href, "_blank", "noopener");
    }
  };

  return (
    <span className="iubendaPolicies">
      <a href={PRIVACY_HREF} onClick={open(privacyRef, PRIVACY_HREF)}>
        Privacy Policy
      </a>
      <span className="policySep" aria-hidden="true">
        |
      </span>
      <a href={COOKIE_HREF} onClick={open(cookieRef, COOKIE_HREF)}>
        Cookie Policy
      </a>

      {/* Hidden anchors that iubenda.js decorates and binds the modal to. */}
      <a
        ref={privacyRef}
        href={PRIVACY_HREF}
        className="iubenda-noiframe iubenda-embed iubendaHidden"
        title="Privacy Policy"
        aria-hidden="true"
        tabIndex={-1}
      >
        Privacy Policy
      </a>
      <a
        ref={cookieRef}
        href={COOKIE_HREF}
        className="iubenda-noiframe iubenda-embed iubendaHidden"
        title="Cookie Policy"
        aria-hidden="true"
        tabIndex={-1}
      >
        Cookie Policy
      </a>
    </span>
  );
};
